export default __webpack_public_path__ + "static/media/049-grenade.adb95d9e.png";